import { render, staticRenderFns } from "./LawyerDetails.vue?vue&type=template&id=0ac9deff"
import script from "./LawyerDetails.vue?vue&type=script&lang=js"
export * from "./LawyerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports